export const presenterUrl = '/presenter';
export const presenterPrintUrl = '/presenter/print';

export default presenterUrl;
